// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/So_ServiceFiscalRemoverInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /so/service_fiscal/remover
 */
import { registerContract } from './validate'

export interface So_ServiceFiscalRemoverInput {
so_service_fiscal_id: number
}

registerContract('So_ServiceFiscalRemoverInput', {
  so_service_fiscal_id: { type: 'number',  required: true },
})
